import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";

var _this = this;

//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
import { chartMixins } from './chartMixins';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartPie',
  mixinis: [chartMixins],
  props: {
    value: Array,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  watch: {
    value: function value(newVal) {
      if (this.dom) {
        this.setOption(newVal);
      } else {
        this.init();
      }
    },
    getechartResize: function getechartResize(newVal, oldVal) {
      if (_this.dom) {
        setTimeout(function () {
          _this.resize();
        }, 500);
      }
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setParams: function setParams(value) {
      var data = [];

      if (value) {
        if (value.length === 1) {
          data.push({
            name: value[0].name,
            type: 'gauge',
            z: 3,
            min: 0,
            max: value[0].total > 0 ? value[0].total * 10 : 800,
            splitNumber: 5,
            // 仪表盘刻度的分割段数,默认 10
            radius: '75%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
                width: 1
              },
              color: '#fff'
            },
            axisTick: {
              // 刻度(线)样式 坐标轴小标记
              length: 6,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: '#fff'
              }
            },
            splitLine: {
              // 分隔线
              length: 5,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto'
              }
            },
            axisLabel: {
              //// 刻度标签
              color: '#00fcff',
              fontSize: 14,
              textStyle: {
                fontSize: 7
              }
            },
            title: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 15,
              color: '#fff',
              fontStyle: 'italic',
              offsetCenter: [0, '80%']
            },
            pointer: {
              // 仪表盘指针。
              show: true,
              // 是否显示指针,默认 true。
              length: "70%",
              // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 5 // 指针宽度,默认 8。

            },
            itemStyle: {
              // 仪表盘指针样式
              color: '#00fcff'
            },
            detail: {
              //// 仪表盘详情，用于显示数据
              fontSize: 14,
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              formatter: function formatter(value) {
                value = (value + '').split('.');
                value.length < 2 && value.push('00');
                return ('00' + value[0]).slice(-2) + '.' + (value[1] + '00').slice(0, 2);
              },
              // fontWeight: 'bolder',
              // borderRadius: 3,
              // backgroundColor: '#444',
              // borderColor: '#aaa',
              // shadowBlur: 5,
              // shadowColor: '#333',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              // borderWidth: 2,
              // textBorderColor: '#000',
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: '#fff',
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontFamily: 'Arial',
              width: 100,
              color: '#ffff00',
              rich: {}
            },
            data: [{
              value: value[0].total,
              name: value[0].name
            }]
          });
        } else if (value.length === 2) {
          data.push({
            name: value[0].name,
            type: 'gauge',
            z: 3,
            min: 0,
            center: ['25%', '50%'],
            // 默认全局居中
            max: value[0].total > 0 ? value[0].total * 10 : 800,
            splitNumber: 5,
            // 仪表盘刻度的分割段数,默认 10
            radius: '75%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
                width: 1
              },
              color: '#fff'
            },
            axisTick: {
              // 刻度(线)样式 坐标轴小标记
              length: 6,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: '#fff'
              }
            },
            splitLine: {
              // 分隔线
              length: 5,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto'
              }
            },
            axisLabel: {
              //// 刻度标签
              color: '#00fcff',
              fontSize: 14,
              textStyle: {
                fontSize: 7
              }
            },
            title: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 15,
              color: '#fff',
              fontStyle: 'italic',
              offsetCenter: [0, '80%']
            },
            pointer: {
              // 仪表盘指针。
              show: true,
              // 是否显示指针,默认 true。
              length: "70%",
              // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 5 // 指针宽度,默认 8。

            },
            itemStyle: {
              // 仪表盘指针样式
              color: '#00fcff'
            },
            detail: {
              //// 仪表盘详情，用于显示数据
              fontSize: 14,
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              formatter: function formatter(value) {
                value = (value + '').split('.');
                value.length < 2 && value.push('00');
                return ('00' + value[0]).slice(-2) + '.' + (value[1] + '00').slice(0, 2);
              },
              // fontWeight: 'bolder',
              // borderRadius: 3,
              // backgroundColor: '#444',
              // borderColor: '#aaa',
              // shadowBlur: 5,
              // shadowColor: '#333',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              // borderWidth: 2,
              // textBorderColor: '#000',
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: '#fff',
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontFamily: 'Arial',
              width: 100,
              color: '#ffff00',
              rich: {}
            },
            data: [{
              value: value[0].total,
              name: value[0].name
            }]
          }, {
            name: value[1].name,
            type: 'gauge',
            z: 3,
            min: 0,
            max: value[0].total > 0 ? value[0].total * 10 : 800,
            center: ['75%', '50%'],
            // 默认全局居中
            splitNumber: 5,
            // 仪表盘刻度的分割段数,默认 10
            radius: '75%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
                width: 1
              },
              color: '#fff'
            },
            axisTick: {
              // 刻度(线)样式 坐标轴小标记
              length: 6,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: '#fff'
              }
            },
            splitLine: {
              // 分隔线
              length: 5,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto'
              }
            },
            axisLabel: {
              //// 刻度标签
              color: '#00fcff',
              fontSize: 14,
              textStyle: {
                fontSize: 7
              }
            },
            title: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 15,
              color: '#fff',
              fontStyle: 'italic',
              offsetCenter: [0, '80%']
            },
            pointer: {
              // 仪表盘指针。
              show: true,
              // 是否显示指针,默认 true。
              length: "70%",
              // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 5 // 指针宽度,默认 8。

            },
            itemStyle: {
              // 仪表盘指针样式
              color: '#00fcff'
            },
            detail: {
              //// 仪表盘详情，用于显示数据
              fontSize: 14,
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              formatter: function formatter(value) {
                value = (value + '').split('.');
                value.length < 2 && value.push('00');
                return ('00' + value[0]).slice(-2) + '.' + (value[1] + '00').slice(0, 2);
              },
              // fontWeight: 'bolder',
              // borderRadius: 3,
              // backgroundColor: '#444',
              // borderColor: '#aaa',
              // shadowBlur: 5,
              // shadowColor: '#333',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              // borderWidth: 2,
              // textBorderColor: '#000',
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: '#fff',
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontFamily: 'Arial',
              width: 100,
              color: '#ffff00',
              rich: {}
            },
            data: [{
              value: value[1].total,
              name: value[1].name
            }]
          });
        } else if (value.length === 3) {
          data.push({
            name: value[0].name,
            type: 'gauge',
            z: 3,
            min: 0,
            max: value[0].total > 0 ? value[0].total * 10 : 800,
            splitNumber: 5,
            // 仪表盘刻度的分割段数,默认 10
            radius: '75%',
            center: ['50%', '50%'],
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
                width: 1
              },
              color: '#fff'
            },
            axisTick: {
              // 刻度(线)样式 坐标轴小标记
              length: 6,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: '#fff'
              }
            },
            splitLine: {
              // 分隔线
              length: 5,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto'
              }
            },
            axisLabel: {
              //// 刻度标签
              color: '#00fcff',
              fontSize: 14,
              textStyle: {
                fontSize: 7
              }
            },
            title: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 15,
              color: '#fff',
              fontStyle: 'italic',
              offsetCenter: [0, '80%']
            },
            pointer: {
              // 仪表盘指针。
              show: true,
              // 是否显示指针,默认 true。
              length: "70%",
              // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 5 // 指针宽度,默认 8。

            },
            itemStyle: {
              // 仪表盘指针样式
              color: '#00fcff'
            },
            detail: {
              //// 仪表盘详情，用于显示数据
              fontSize: 14,
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              formatter: function formatter(value) {
                value = (value + '').split('.');
                value.length < 2 && value.push('00');
                return ('00' + value[0]).slice(-2) + '.' + (value[1] + '00').slice(0, 2);
              },
              // fontWeight: 'bolder',
              // borderRadius: 3,
              // backgroundColor: '#444',
              // borderColor: '#aaa',
              // shadowBlur: 5,
              // shadowColor: '#333',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              // borderWidth: 2,
              // textBorderColor: '#000',
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: '#fff',
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontFamily: 'Arial',
              width: 100,
              color: '#ffff00',
              rich: {}
            },
            data: [{
              value: value[0].total,
              name: value[0].name
            }]
          }, {
            name: value[1].name,
            type: 'gauge',
            center: ['21%', '50%'],
            // 默认全局居中
            radius: '70%',
            min: 0,
            max: value[1].total > 0 ? value[1].total * 10 : 800,
            endAngle: 45,
            splitNumber: 5,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
                width: 1
              }
            },
            axisTick: {
              // 坐标轴小标记
              length: 6,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: '#fff'
              }
            },
            axisLabel: {
              //// 刻度标签
              color: '#00fcff',
              fontSize: 14,
              textStyle: {
                fontSize: 7
              }
            },
            splitLine: {
              // 分隔线
              length: 5,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto'
              }
            },
            pointer: {
              show: true,
              // 是否显示指针,默认 true。
              length: "70%",
              // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 5 // 指针宽度,默认 8。

            },
            itemStyle: {
              // 仪表盘指针样式
              color: '#00fcff'
            },
            title: {
              offsetCenter: [0, '80%'],
              // x, y，单位px
              fontSize: 15,
              color: '#fff'
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 14,
              color: '#ffff00'
            },
            data: [{
              value: value[1].total,
              name: value[1].name
            }]
          }, {
            name: value[2].name,
            type: 'gauge',
            center: ['79%', '50%'],
            // 默认全局居中
            radius: '70%',
            min: 0,
            max: value[2].total > 0 ? value[2].total * 10 : 800,
            startAngle: 135,
            endAngle: -60,
            splitNumber: 5,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
                width: 1
              }
            },
            axisTick: {
              // 坐标轴小标记
              length: 4,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: '#fff'
              }
            },
            axisLabel: {
              color: '#00fcff',
              fontSize: 14,
              textStyle: {
                fontSize: 7
              }
            },
            splitLine: {
              // 分隔线
              length: 5,
              // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: '#fff'
              }
            },
            pointer: {
              show: true,
              // 是否显示指针,默认 true。
              length: "70%",
              // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 5 // 指针宽度,默认 8。

            },
            itemStyle: {
              // 仪表盘指针样式
              color: '#00fcff'
            },
            title: {
              offsetCenter: [0, '80%'],
              // x, y，单位px
              fontSize: 15,
              color: '#fff'
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 14,
              color: '#ffff00'
            },
            data: [{
              value: value[2].total,
              name: value[2].name
            }]
          });
        }
      }

      this.option = {
        tooltip: {
          formatter: "{a} <br/>{c} {b}"
        },
        title: {
          text: this.text,
          x: 'left',
          top: '5',
          left: '5',
          textStyle: {
            fontSize: '14',
            color: 'white',
            fontWeight: 'normal'
          }
        },
        series: data // series: [
        //   {
        //     name: '速度',
        //     type: 'gauge',
        //     z: 3,
        //     min: 0,
        //     max: 800,
        //     splitNumber: 5,// 仪表盘刻度的分割段数,默认 10
        //     radius: '75%',
        //     axisLine: {            // 坐标轴线
        //       lineStyle: {       // 属性lineStyle控制线条样式
        //         color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
        //         width: 1,
        //       },
        //       color: '#fff'
        //     },
        //     axisTick: {            // 刻度(线)样式 坐标轴小标记
        //       length: 6,        // 属性length控制线长
        //       lineStyle: {       // 属性lineStyle控制线条样式
        //         color: '#fff'
        //       }
        //     },
        //     splitLine: {           // 分隔线
        //       length: 5,         // 属性length控制线长
        //       lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
        //         color: 'auto'
        //       }
        //     },
        //     axisLabel: {//// 刻度标签
        //       color: '#00fcff',
        //       fontSize:14,
        //       textStyle:{
        //         fontSize:7
        //       }
        //     },
        //     title: {
        //       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        //       fontWeight: 'bolder',
        //       fontSize: 15,
        //       color: '#fff',
        //       fontStyle: 'italic',
        //       offsetCenter:[0,'80%'],
        //     },
        //     pointer: { // 仪表盘指针。
        //       show: true, // 是否显示指针,默认 true。
        //       length: "70%", // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
        //       width: 5, // 指针宽度,默认 8。
        //
        //     },
        //     itemStyle:{// 仪表盘指针样式
        //       color: '#00fcff',
        //     },
        //     detail: {//// 仪表盘详情，用于显示数据
        //       fontSize: 14,
        //       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        //       formatter: function (value) {
        //         value = (value + '').split('.');
        //         value.length < 2 && (value.push('00'));
        //         return ('00' + value[0]).slice(-2)
        //           + '.' + (value[1] + '00').slice(0, 2);
        //       },
        //       // fontWeight: 'bolder',
        //       // borderRadius: 3,
        //       // backgroundColor: '#444',
        //       // borderColor: '#aaa',
        //       // shadowBlur: 5,
        //       // shadowColor: '#333',
        //       shadowOffsetX: 0,
        //       shadowOffsetY: 3,
        //       // borderWidth: 2,
        //       // textBorderColor: '#000',
        //       textBorderWidth: 2,
        //       textShadowBlur: 2,
        //       textShadowColor: '#fff',
        //       textShadowOffsetX: 0,
        //       textShadowOffsetY: 0,
        //       fontFamily: 'Arial',
        //       width: 100,
        //       color: '#ffff00',
        //       rich: {}
        //     },
        //     data: [{value: 40, name: 'km/h'}]
        //   },
        //   {
        //     name: '转速',
        //     type: 'gauge',
        //     center: ['20%', '55%'],    // 默认全局居中
        //     radius: '70%',
        //     min: 0,
        //     max: 7,
        //     endAngle: 45,
        //     splitNumber:5,
        //     axisLine: {            // 坐标轴线
        //       lineStyle: {       // 属性lineStyle控制线条样式
        //         color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
        //         width: 1
        //       }
        //     },
        //     axisTick: {            // 坐标轴小标记
        //       length: 6,        // 属性length控制线长
        //       lineStyle: {       // 属性lineStyle控制线条样式
        //         color: '#fff'
        //       }
        //     },
        //     axisLabel: {//// 刻度标签
        //       color: '#00fcff',
        //       fontSize:14,
        //       textStyle:{
        //         fontSize:7
        //       }
        //     },
        //     splitLine: {           // 分隔线
        //       length: 5,         // 属性length控制线长
        //       lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
        //         color: 'auto'
        //       }
        //     },
        //     pointer: {
        //       show: true, // 是否显示指针,默认 true。
        //       length: "70%", // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
        //       width: 5, // 指针宽度,默认 8。
        //     },
        //     itemStyle:{// 仪表盘指针样式
        //       color: '#00fcff',
        //     },
        //     title: {
        //       offsetCenter: [0, '80%'],       // x, y，单位px
        //       fontSize: 15,
        //       color: '#fff',
        //     },
        //     detail: {
        //       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        //       fontWeight: 'bolder',
        //       fontSize: 14,
        //       color: '#ffff00',
        //     },
        //     data: [{value: 1.5, name: 'x1000 r/min'}]
        //   },
        //   {
        //     name: '油表',
        //     type: 'gauge',
        //     center: ['77%', '50%'],    // 默认全局居中
        //     radius: '60%',
        //     min: 0,
        //     max: 2,
        //     startAngle: 135,
        //     endAngle: -60,
        //     splitNumber: 5,
        //     axisLine: {            // 坐标轴线
        //       lineStyle: {       // 属性lineStyle控制线条样式
        //         color: [[0.09, '#fff'], [0.82, '#fff'], [1, '#fff']],
        //         width: 1
        //       }
        //     },
        //     axisTick: {            // 坐标轴小标记
        //       length: 4,        // 属性length控制线长
        //       lineStyle: {        // 属性lineStyle控制线条样式
        //         color: '#fff'
        //       }
        //     },
        //     axisLabel: {
        //       color: '#00fcff',
        //       fontSize:14,
        //       textStyle:{
        //         fontSize:7
        //       }
        //     },
        //     splitLine: {           // 分隔线
        //       length: 5,         // 属性length控制线长
        //       lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
        //         color: '#fff'
        //       }
        //     },
        //     pointer: {
        //       show: true, // 是否显示指针,默认 true。
        //       length: "70%", // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
        //       width: 5, // 指针宽度,默认 8。
        //     },
        //     itemStyle:{// 仪表盘指针样式
        //       color: '#00fcff',
        //     },
        //     title: {
        //       offsetCenter: [0, '80%'],       // x, y，单位px
        //       fontSize: 15,
        //       color: '#fff',
        //     },
        //     detail: {
        //       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        //       fontWeight: 'bolder',
        //       fontSize: 14,
        //       color: '#ffff00',
        //     },
        //     data: [{value: 0.5, name: 'gas'}]
        //   },
        //   // {
        //   //   name: '水表',
        //   //   type: 'gauge',
        //   //   center: ['77%', '50%'],    // 默认全局居中
        //   //   radius: '25%',
        //   //   min: 0,
        //   //   max: 2,
        //   //   startAngle: 315,
        //   //   endAngle: 225,
        //   //   splitNumber: 2,
        //   //   axisLine: {            // 坐标轴线
        //   //     lineStyle: {       // 属性lineStyle控制线条样式
        //   //       width: 8
        //   //     }
        //   //   },
        //   //   axisTick: {            // 坐标轴小标记
        //   //     show: false
        //   //   },
        //   //   axisLabel: {
        //   //     formatter: function(v){
        //   //       switch (v + '') {
        //   //         case '0' : return 'H';
        //   //         case '1' : return 'Water';
        //   //         case '2' : return 'C';
        //   //       }
        //   //     },
        //   //     textStyle:{
        //   //       fontSize:7
        //   //     }
        //   //   },
        //   //   splitLine: {           // 分隔线
        //   //     length: 5,         // 属性length控制线长
        //   //     lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
        //   //       color: 'auto'
        //   //     }
        //   //   },
        //   //   pointer: {
        //   //     width:2
        //   //   },
        //   //   title: {
        //   //     show: false
        //   //   },
        //   //   detail: {
        //   //     show: false
        //   //   },
        //   //   data: [{value: 0.5, name: 'gas'}]
        //   // }
        // ]

      };
      return this.option;
    },
    init: function init() {
      var _this2 = this;

      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(this.setParams(this.value));
      setTimeout(function () {
        _this2.resize();
      });
      on(window, 'resize', this.resize);
    },
    setOption: function setOption(value) {
      this.dom.setOption(this.setParams(value));
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};